export class ParcelSchedulingError {
  message?: string;
  errorCode?: string;

  constructor(opts?: Partial<ParcelSchedulingError>) {
    if (opts?.message != null) {
      this.message = opts.message;
    }
    if (opts?.errorCode != null) {
      this.errorCode = opts.errorCode;
    }
  }
}
